module.exports = __webpack_public_path__ + "static/steam_engine-9a0d05299664b6a5ce94bf63452255b3.jpeg";